export const lunchroom = {
  seo: {
    title: 'Case: Two-B Lunchroom | Bistroo',
    description: 'Hoe Two-B, de allerlekkerste broodjes in de regio, online groeide dankzij Bistroo.',
  },
  hero: {
    title: 'Two-B "de allerlekkerste broodjes in de regio" groeit online door Bistroo',
    description:
      'Two B by Mondie is een welbekend adres in Veldhoven en omstreken, en heeft onlangs ook een nieuwe vestiging geopend in Helmond & Best. Ze bedienen de hele regio met heerlijke broodjes.',
  },
  testimonials: {
    1: {
      text: '"Bistroo bespaart ons dagelijks veel tijd en vermindert de frustratie bij onze klanten aanzienlijk."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
    2: {
      text: '"Het menu is makkelijk aan te passen en biedt klanten een duidelijk overzicht."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'Innovatie heeft tijd nodig',
      text: 'Voorheen waren telefonische bestellingen en afhalen aan de balie de voornaamste manieren om klanten te bedienen, wat resulteerde in lange wachtrijen en inefficiënties tijdens drukke momenten. De eigenaar, Lars, werkt al meer dan 2 jaar samen met Bistroo en deelt graag enkele uitdagingen die ze ondervonden voor de samenwerking, evenals de oplossingen die Bistroo biedt.',
    },
    paragraph_2: {
      title: 'De uitdaging',
      bullets: {
        1: 'Two B By Mondie had vaak te maken met drukte tijdens de lunchuren, wat leidde tot lange wachtrijen en minder tevreden klanten.',
        2: 'Bestellingen via de telefoon zorgden voor vertragingen en verwarring, vooral tijdens drukke uren.',
        3: 'Door menselijke fouten en miscommunicatie bij telefonische bestellingen kwamen orders soms verkeerd door, wat resulteerde in ontevreden klanten en verspilde tijd.',
        4: 'Klanten wilden steeds vaker online bestellen vanwege het gemak en verwachtten een naadloze afhaalervaring zonder lange wachttijden.',
      },
    },
  },
  solution: {
    title: 'De oplossing',
    checklist: {
      1: 'Dankzij Bistroo konden klanten hun bestellingen van tevoren plaatsen, waardoor Two B By Mondie tijdens drukke momenten efficiënter kon werken en klanten direct konden afhalen zonder te wachten.',
      2: "Met Bistroo's online besteloplossing had Two B By Mondie een duidelijk overzicht van bestellingen, waardoor fouten werden verminderd en de keuken efficiënter kon werken.",
      3: 'Met Bistroo kon Two B By Mondie hun eigen drukke periodes beheren, waardoor ze de klantervaring konden verbeteren en de omzet konden maximaliseren.',
      4: 'Alle bestellingen via Bistroo werden vooraf betaald, wat het risico op niet opgehaalde bestellingen verminderde en zorgde voor een soepelere afhandeling aan de balie.',
    },
  },
  conclusion: {
    title: 'De conclusie',
    text: {
      1: 'Bistroo\'s online besteloplossing bood Two B By Mondie niet alleen een effectieve manier om deze uitdagingen aan te pakken, maar transformeerde ook hun bedrijfsvoering. "Sinds we met Bistroo samenwerken, kunnen onze klanten hun bestellingen eenvoudig online plaatsen. Dit bespaart ons dagelijks veel tijd en vermindert de frustratie bij onze klanten aanzienlijk," aldus Lars. Hij waardeert ook de gebruiksvriendelijkheid van het menu-aanpassingssysteem en de uitstekende klantenservice van Bistroo: "Als we vragen hebben, krijgen we snel en deskundig hulp."',
      2: "Bovendien biedt Bistroo altijd een proefperiode van 30 dagen, waarin klanten kosteloos van de dienst gebruik kunnen maken. In vrijwel alle gevallen is er een wederzijdse intentie om door te gaan met het gebruik van Bistroo's online besteloplossing, wat getuigt van de waarde en effectiviteit van de bestelsoftware voor lunchrooms zoals Two B By Mondie",
    },
  },
}
